/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Prioritization_TextInputs */

const fr_help_prioritization_text = /** @type {(inputs: Help_Prioritization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'application est gourmande en ressources. Les réseaux sont ajoutés selon l'intérêt général et la faisabilité technique.`)
};

const en_help_prioritization_text = /** @type {(inputs: Help_Prioritization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The application is resource-intensive. Networks are added according to general interest and technical feasibility.`)
};

/**
* | output |
* | --- |
* | "The application is resource-intensive. Networks are added according to general interest and technical feasibility." |
*
* @param {Help_Prioritization_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_prioritization_text = /** @type {((inputs?: Help_Prioritization_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Prioritization_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_prioritization_text(inputs)
	return en_help_prioritization_text(inputs)
});